import options from './get-focus.directive';

export default {
    selector: 'getFocus',
    options
};



// WEBPACK FOOTER //
// ./app/common/get-focus/index.js